import { node } from "prop-types";

import HtmlContent from "../../components/html-content/HtmlContent";

export default function ResourceDetails({ details }) {
  if (!details) {
    return null;
  }

  return (
    <div className="tds-typography--italic">
      <HtmlContent
        paragraphBodyStyle={1}
        paragraphMargin="ua-margin-xsm-bottom"
        rawHtml={details}
      />
    </div>
  );
}

ResourceDetails.propTypes = {
  details: node,
};
